
import { Helmet } from 'react-helmet-async';
import PageLayout from '@/components/layout/PageLayout';
import Hero from '@/components/home/Hero';
import ClassesSection from '@/components/home/ClassesSection';
import AboutPreview from '@/components/home/AboutPreview';
// import TestimonialsSection from '@/components/home/TestimonialsSection';
import CtaSection from '@/components/home/CtaSection';

const Index = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>OMAC-UK | Leading Taekwondo School in Nottingham</title>
        <meta name="description" content="OMAC-UK is Nottingham's premier Taekwondo academy offering classes for all ages. Join Master Juliet Williams for British Taekwondo training in Gedling." />
        <meta name="keywords" content="Taekwondo Nottingham, Martial Arts Nottingham, Taekwondo Classes, UK Taekwondo, Nottingham Taekwondo, Gedling Taekwondo, British Taekwondo, Taekwondo Classes, Master Juliet Williams, Self-Defence Training, World Taekwondo, MooGongRyu, Hapkido, Kids Taekwondo, Adult Martial Arts, OMAC-UK, OMAC UK" />
        <meta property="og:title" content="OMAC-UK | Premier Taekwondo Academy in Nottingham" />
        <meta property="og:description" content="Join Nottingham's leading Taekwondo school. Classes for all ages with Master Juliet Williams in Gedling. British Taekwondo certified training." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://omac-uk.co.uk" />
        <meta property="og:image" content="/images/juliet/juliet_kick.jpeg" />
        <link rel="canonical" href="https://omac-uk.co.uk" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MartialArtsSchool",
              "name": "OMAC-UK Taekwondo",
              "description": "Nottingham's leading Taekwondo academy offering classes for all ages under Master Juliet Williams.",
              "url": "https://omac-uk.co.uk",
              "logo": "https://omac-uk.co.uk/omac_logo.png",
              "image": "https://omac-uk.co.uk/images/juliet/juliet_kick.jpeg",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "65 Gedling Road",
                "addressLocality": "Gedling",
                "addressRegion": "Nottingham",
                "postalCode": "NG4 3FG",
                "addressCountry": "UK"
              },
              "telephone": "01159874857",
              "openingHoursSpecification": [
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": ["Monday"],
                  "opens": "17:30",
                  "closes": "20:30"
                },
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": ["Tuesday"],
                  "opens": "16:30",
                  "closes": "20:00"
                },
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": ["Wednesday"],
                  "opens": "17:30",
                  "closes": "20:30"
                },
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": ["Thursday"],
                  "opens": "16:30",
                  "closes": "20:00"
                },
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": ["Saturday"],
                  "opens": "09:30",
                  "closes": "13:30"
                }
              ],
              "offers": {
                "@type": "Offer",
                "description": "Taekwondo classes for all ages and abilities"
              }
            }
          `}
        </script>
      </Helmet>
      <Hero />
      <ClassesSection />
      <AboutPreview />
      {/*<TestimonialsSection />*/}
      <CtaSection />
    </PageLayout>
  );
};

export default Index;
